export default __webpack_public_path__ + "static/media/J750MANA3.ca758ad6.pdf";